import React, { ReactNode } from "react"
import { Box } from "@mui/material";
import { Service } from "../../../assets/types";

export interface ServiceSectionProps {
  service: Service
  headline?: string
  className?: string
  children?: ReactNode
}

const ServiceSection = (props: ServiceSectionProps) => {
  return (
    <Box sx={{ flexGrow: 1, marginBottom: "64px" }} className={props.className}>
      <h3>{props.headline}</h3>
      {props.children}
    </Box>
  )
}

export default ServiceSection
